import Axios from 'axios';

// Create an instance with default configs
const axios = Axios.create({
    baseURL: '/',
    timeout: 20000,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    }
});

axios.interceptors.response.use(
    response => response,
    error => {
        const { response } = error;

        if (!response) {
            console.error('Network error:', error.message);
        } else {
            switch (response.status) {
                case 401:
                    console.warn('Unauthorized');
                    break;
                case 403:
                    console.warn('Forbidden');
                    break;
                case 500:
                    console.error('Server Error:', response.data);
                    break;
                default:
                    console.warn('API Error:', response.data?.message || error.message);
            }
        }

        return Promise.reject(error);
    }
);

// Named export
export { axios };
